import useTranslator from "../../hooks/useTranslator";
import UserIcon from "../../assets/img/user-icon.svg";
import { Button, Modal } from "../design";
import "./SuccessAwardedPropModal.css";

const SuccessAwardedPropModal = (props) => {
  const { _t } = useTranslator();
  const {
    showSuccessPopup,
    setShowSuccessPopup,
    property,
    successTenant,
    onClose,
  } = props;

  const handleClose = () => {
    setShowSuccessPopup(false);
    onClose?.();
  };

  return (
    <>
      <Modal
        open={showSuccessPopup}
        onClose={handleClose}
        id="success-awarded-prop-modal"
        icon={
          <div className="checkmarkWrapper">
            <img src="/images/checkmarkIconGreen.svg" alt="" />
          </div>
        }
        title={_t(
          "propertyAwardedSuccessfully",
          "New award property succes modal"
        )}
        description={
          <>
            {_t("theProperty", "New award property succes modal")}{" "}
            <strong>
              {`${property?.street || ""}${
                !Number.isNaN(parseInt(property?.street_number, 10))
                  ? ` - ${parseInt(property?.street_number, 10)}`
                  : ""
              }${property?.floor_number ? `, ${property.floor_number}` : ""}${
                property?.flat_number ? `-${property.flat_number}` : ""
              }`}
            </strong>
            {_t("hasBeenAwardedTo", "New award property succes modal")}
          </>
        }
        actions={
          <Button size="lg" block onClick={handleClose}>
            {_t(
              "underStoodButtonAfterAwardProp",
              "New award property succes modal"
            )}
          </Button>
        }
      >
        <ul className="success-awarded-list">
          {successTenant?.map((tenantName) => (
            <li>
              <div className="earner-thumbnail-wrapper d-flex align-items-center justify-content-center">
                <img src={UserIcon} alt="User Icon" />
              </div>
              {tenantName}
            </li>
          ))}
        </ul>
      </Modal>
    </>
  );
};

export default SuccessAwardedPropModal;
